// Like the legacy preheat scheduler, start at most four tasks per idle period and wait for them to settle.
const PREHEAT_BATCH_SIZE = 4

export function runPreheatTasksWhenIdle(tasks: ReadonlyArray<() => Promise<void>>, signal: AbortSignal) {
  if (typeof window.requestIdleCallback !== 'function') return

  let next = 0
  let idleCallback: number | undefined

  function scheduleNextBatch() {
    if (signal.aborted || next >= tasks.length) return
    idleCallback = requestIdleCallback(() => {
      idleCallback = undefined
      void runBatch()
    })
  }

  async function runBatch() {
    const batch = tasks.slice(next, next + PREHEAT_BATCH_SIZE)
    next += batch.length
    await Promise.allSettled(batch.map(task => task()))
    scheduleNextBatch()
  }

  signal.addEventListener(
    'abort',
    () => {
      if (idleCallback !== undefined) cancelIdleCallback(idleCallback)
    },
    {once: true},
  )
  scheduleNextBatch()
}
